import {financeAPI} from "../../axios";

export const state = {
  entityList: [],
  isEntityListLoading: false,
};
export const mutations = {
  SET_ENTITY_LIST(state, payload) {
    state.entityList = payload;
  },
  SET_ENTITY_LIST_LOADING(state, payload) {
    state.isEntityListLoading = payload;
  },
};
export const actions = {
  getClientByIdAndType(context, { campusId, id, type }) {
    return financeAPI.get(`Client/GetClientByIdAndType/${campusId}/${id}/${type}`);
  },
  getClientByType(context, { campusId, type }) {
    return financeAPI.get(`Client/Type/${campusId}/${type}`);
  },
};

export const getters = {
  getEntityList(state) {
    return state.entityList;
  },
};
